export const solutions = [
  {
    slug: "small-business",
    icon: "Building2",
    seoTitle: "Cybersecurity for Small & Midsize Businesses | Aliwer",
    seoDescription:
      "Right-sized cybersecurity for SMBs: assessments, essential controls, compliance, and managed protection without enterprise overhead.",
    title: "Cybersecurity for Small & Midsize Businesses",
    card: "Right-sized protection for growing teams — security outcomes without enterprise overhead.",
    intro:
      "Growing businesses face enterprise-grade threats without enterprise-grade budgets. We focus your investment on the controls that reduce the most risk, fast.",
    whatWeDo: [
      "Baseline assessment to find your highest-impact gaps.",
      "Implement essential controls: identity, backups, endpoint, and email security.",
      "Practical compliance for customer and insurance requirements.",
      "Managed protection so you don't need a full in-house team.",
    ],
    deliverables: [
      "Prioritized risk snapshot and roadmap.",
      "Essential controls configured and documented.",
      "Ongoing monitoring options.",
    ],
    whoFor: "Small and midsize businesses that need meaningful protection on a practical budget.",
  },
  {
    slug: "regulated-organizations",
    icon: "Landmark",
    seoTitle: "Cybersecurity for Regulated Organizations | Aliwer",
    seoDescription:
      "Security and compliance for regulated organizations: controls, evidence, risk management, and audit-ready documentation for HIPAA, SOC 2, and more.",
    title: "Cybersecurity for Regulated Organizations",
    card: "Meet HIPAA, SOC 2, and industry mandates with controls that are genuinely secure.",
    intro:
      "Regulated organizations must prove security, not just claim it. We build programs that satisfy auditors and actually reduce risk.",
    whatWeDo: [
      "Map requirements to concrete, testable controls.",
      "Build evidence collection and risk management.",
      "Prepare for and support audits.",
      "Establish continuous compliance instead of point-in-time scrambles.",
    ],
    deliverables: [
      "Control framework and policy set.",
      "Evidence and risk register.",
      "Audit-ready documentation and support.",
    ],
    whoFor: "Healthcare, finance, and other organizations with regulatory or contractual security obligations.",
  },
  {
    slug: "cloud-first",
    icon: "Cloud",
    seoTitle: "Cloud-First Security Solutions | Aliwer",
    seoDescription:
      "Secure cloud-first organizations: architecture, identity, configuration, workload protection, logging, and cloud governance.",
    title: "Cloud-First Security Solutions",
    card: "Secure, well-governed cloud environments across AWS, Azure, and Google Cloud.",
    intro:
      "Cloud-first speed is a competitive advantage — until a misconfiguration becomes a breach. We help you move fast and stay secure.",
    whatWeDo: [
      "Cloud architecture and configuration hardening.",
      "Identity and least-privilege access design.",
      "Workload, container, and data protection.",
      "Logging, detection, and cloud governance guardrails.",
    ],
    deliverables: [
      "Cloud posture assessment and fixes.",
      "Identity and guardrail baseline.",
      "Detection and monitoring setup.",
    ],
    whoFor: "Cloud-native and cloud-migrating organizations that need security to keep pace with delivery.",
  },
  {
    slug: "ai-enabled",
    icon: "Cpu",
    seoTitle: "Cybersecurity for AI-Enabled Organizations | Aliwer",
    seoDescription:
      "Secure AI adoption: AI risk assessment, data exposure controls, prompt-threat mitigation, governance, and secure integration.",
    title: "Cybersecurity for AI-Enabled Organizations",
    card: "Adopt AI confidently with governance, data controls, and risk assessment.",
    intro:
      "AI unlocks new capabilities and new risks. We help you adopt AI with data protection, governance, and clear-eyed risk management.",
    whatWeDo: [
      "Assess AI data exposure and model risk.",
      "Mitigate prompt-injection and access threats.",
      "Establish AI governance and acceptable use.",
      "Secure AI integration into products and workflows.",
    ],
    deliverables: [
      "AI risk assessment and findings.",
      "Governance and acceptable-use policy.",
      "Data and access control recommendations.",
    ],
    whoFor: "Organizations building with or adopting AI who want to manage data, model, and governance risk.",
  },
];
